import { Clock3 } from 'lucide-react';
import { responseState, type ResponseWait } from '@/lib/responseTime';
import { useResponseClock } from '@/lib/responseClock';
import { messageTime } from '@/lib/conversation';
import { LiveValue } from './LiveValue';
import { cn } from './cn';

export function ResponseTimer({
  wait,
  now,
  timeZone = 'Europe/Moscow',
}: {
  wait: ResponseWait;
  now?: number;
  timeZone?: string;
}) {
  const clock = useResponseClock(now);
  const state = responseState(wait, clock);
  const title =
    state.age === null
      ? 'Начало ожидания неизвестно или ещё не наступило'
      : 'Ожидание с ' + messageTime(wait.since, timeZone, true) + (state.label ? ' · ' + state.label : '');
  return (
    <span
      data-slot="response-timer"
      data-tone={state.tone}
      title={title}
      className={cn(
        'inline-flex h-5 w-60 max-w-full items-center gap-1.5 text-xs whitespace-nowrap tabular-nums',
        state.tone === 'danger'
          ? 'text-danger-strong'
          : state.tone === 'warning'
            ? 'text-warning-fg'
            : 'text-fg-muted',
      )}
    >
      <Clock3 className="size-3.5 shrink-0" aria-hidden />
      <span>Ждёт ответа</span>
      <LiveValue value={state.value} variant="elapsed" />
      {state.label && <span className="sr-only">{state.label}</span>}
    </span>
  );
}
